<!--
	NOTE: see TextInput NOTE on disabling autocomplete. i have to do some of
	the steps at runtime here though because the input field is instrumented
	by Google after the page loads
-->

<script>
	import { onMount } from 'svelte';
	
	export let id;
	export let kitchenAddress;
	export let label;
	export let onAddressChangeFn;
	export let value;
	export let width = "90%";
	
	let focused;
	
	function __id() {
		return 'disableAutocompletePrefix-'+id+'-disableAutocompleteSuffix';
	}
	
	/* setup delivery address autocomplete widget */
	function initAddressAutocomplete() {
		//REFS: https://developers.google.com/maps/documentation/javascript/places-autocomplete
		let deliveryRadius = 
			new google.maps.Circle({
				center: kitchenAddress,
	  			radius: 50000 //50km
  			});
  		
  		let inputEl = document.getElementById(__id());
		let widget = new google.maps.places.Autocomplete( 
							inputEl, 
							{ fields: ['name','formatted_address','types'],
							  bounds: deliveryRadius.getBounds(),
							  componentRestrictions: {country: 'my'} });
		
		widget.addListener('place_changed', () => {
		    /* NOTE: !choice.types means the address was not selected from 
		       the suggestion dropdown */
			let isSuggestedAddr = !!widget.getPlace().types;
			if( isSuggestedAddr )
				value = inputEl.value;
		});	
	}
	
	function input() {
		let inputEl = document.getElementById(__id());
		return inputEl ? inputEl.value : '';
	}
	
	$: onAddressChangeFn(value);
	
	onMount( () => {
		initAddressAutocomplete();
	});
</script>

<style type="text/scss">
	@import "./style/theme.scss";

	#root {
		margin-bottom: 15px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 15px;
		position: relative;
		
		.label {
			@extend .column-container;
			position: absolute;
			margin-left: 15px;
			pointer-events: none;
			top: 1em;

			&.focused {
				color: $halo-logo-halo-color;
				font-size: 0.8em;
				margin-left: 5px;
				top: 0;
			}
		}
		
		input {
			border: none; 
			border-bottom-width: 3px;
			border-bottom-style: solid;
			border-bottom-color: $default-fg-color;
			outline: none;
			padding-top: 1em;
			width: 100%;
			
			&.invalid {
				border-bottom-color: $error-color;
			}
			
			&::-webkit-input-placeholder {
				font-size: 0.8em;
			}
		}
	}
</style>

<div id="root"
	style="width:{width}">
	<div class="label"
		class:focused={focused || value || input()}>
		{label}
	</div>
	<input id={__id()} 
		class="location"
		type="text" 
		class:invalid={!value}
		placeholder={focused ? 'Search for and select your address' : ''}
		value={value}
		on:input={ev => value = ''}			
		on:blur={() => focused = false}
		on:focus={ev => {
			focused = true;
			ev.target.autocomplete = 'nope';
		}}
		on:click|stopPropagation={ev => ev.target.focus()}>
</div>
